import script from "./WatchlistOrderNotificationSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchlistOrderNotificationSettings.vue?vue&type=script&setup=true&lang=ts"

import "./WatchlistOrderNotificationSettings.vue?vue&type=style&index=0&id=90d6e552&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90d6e552"]])

export default __exports__